import React from "react";
import { useLocation } from "react-router-dom";

const ScrollUp = () => {
  const location = useLocation();

  return (
    <>
      <div
        className="pullUp resize"
        style={{ bottom: "126px", right: "23px", zIndex: 9998 }}
        onClick={(e) => window.scrollTo({ top: 0, behavior: "smooth" })}
        title="Scroll to Top"
      >
        <b className="icon-arrow-right" />
      </div>
      <div
        className="pullUp resize"
        style={{ bottom: "78px", right: "23px", zIndex: 9998 }}
        onClick={(e) =>
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: "smooth",
          })
        }
        title="Scroll to Bottom"
      >
        <b className="icon-arrow-left" />
      </div>
    </>
  );
};

export default ScrollUp;
